// Paginate.js
import React from "react";
import { Pagination } from "react-bootstrap";

const Paginate = ({ currentPage, totalPages, onPageChange }) => {
  const maxVisiblePages = 5;
  
  // Calculate start and end pages
  let startPage = Math.max(currentPage - Math.floor(maxVisiblePages / 2), 1);
  let endPage = startPage + maxVisiblePages - 1;
  
  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(endPage - maxVisiblePages + 1, 1);
  }
  
  const pages = [];
  
  // If first page isn't in range, add page 1 and ellipsis if needed.
  if (startPage > 1) {
    pages.push(
      <Pagination.Item key={1} active={currentPage === 1} onClick={() => onPageChange(1)}>
        1
      </Pagination.Item>
    );
    if (startPage > 2) {
      pages.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
    }
  }
  
  for (let i = startPage; i <= endPage; i++) {
    pages.push(
      <Pagination.Item key={i} active={currentPage === i} onClick={() => onPageChange(i)}>
        {i}
      </Pagination.Item>
    );
  }
  
  // If last page isn't in range, add ellipsis and last page.
  if (endPage < totalPages) {
    if (endPage < totalPages - 1) {
      pages.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
    }
    pages.push(
      <Pagination.Item key={totalPages} active={currentPage === totalPages} onClick={() => onPageChange(totalPages)}>
        {totalPages}
      </Pagination.Item>
    );
  }
  
  return (
    <Pagination className="justify-content-center">
      <Pagination.Prev 
        onClick={() => onPageChange(Math.max(currentPage - 1, 1))} 
        disabled={currentPage === 1}
      />
      {pages}
      <Pagination.Next 
        onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))} 
        disabled={currentPage === totalPages}
      />
    </Pagination>
  );
};

export default Paginate;
